export class TrainAuth {
    constructor() {
        this.walletSignRegistry = new Map();
    }
    registerWalletSign(providerName, factory) {
        this.walletSignRegistry.set(providerName, factory);
    }
    deriveKeyFromWallet(providerName, config) {
        const factory = this.walletSignRegistry.get(providerName);
        if (!factory) {
            throw new Error(`No wallet sign registered for provider: ${providerName}. ` +
                `Did you forget to call the corresponding register function (e.g. registerEvmSdk())?`);
        }
        return factory(config);
    }
    getRegisteredWalletSignProviders() {
        return Array.from(this.walletSignRegistry.keys());
    }
}
// Default instance + backward-compat free functions
export const defaultTrainAuth = new TrainAuth();
export function registerWalletSign(providerName, factory) {
    return defaultTrainAuth.registerWalletSign(providerName, factory);
}
export function deriveKeyFromWallet(providerName, config) {
    return defaultTrainAuth.deriveKeyFromWallet(providerName, config);
}
export function getRegisteredWalletSignProviders() {
    return defaultTrainAuth.getRegisteredWalletSignProviders();
}
